import React, { useState } from 'react';
import { getBadgeIcon, formatBadgeDate } from '../../../utils/badgeHelpers';
import { trackEvent } from '../../../utils/analytics';

const BadgeChip = ({ badge, compact = false }) => {
  const [showTooltip, setShowTooltip] = useState(false);
  const Icon = getBadgeIcon(badge.category);

  const handleTooltipShow = () => {
    setShowTooltip(true);
    trackEvent('badge_tooltip_viewed', { badge_code: badge.code, badge_category: badge.category });
  };

  return (
    <div
      className="relative flex items-center shrink-0"
      onMouseEnter={handleTooltipShow}
      onMouseLeave={() => setShowTooltip(false)}
      onTouchStart={handleTooltipShow}
      onTouchEnd={() => setShowTooltip(false)}
    >
      <div className={`
        flex items-center gap-1.5 rounded-full border 
        ${badge.category === 'verified' 
          ? 'bg-blue-50 border-blue-200 text-blue-700' 
          : 'bg-teal-50 border-teal-200 text-teal-700'} 
        ${compact ? 'px-2 py-0.5 text-xs' : 'px-3 py-1 text-sm'}
        font-medium transition-colors hover:bg-opacity-80 shadow-sm cursor-default
      `}>
        <Icon size={compact ? 12 : 16} className={badge.category === 'verified' ? 'text-blue-600' : 'text-teal-600'} />
        <span>{badge.label}</span>
      </div>

      {showTooltip && (
        <div className="absolute top-full left-1/2 -translate-x-1/2 mt-2 w-max max-w-xs z-50 p-2.5 rounded-lg shadow-lg bg-gray-900 text-white text-xs text-center border border-gray-700 pointer-events-none animate-in fade-in slide-in-from-top-1 duration-200">
          <p className="font-semibold mb-1">{badge.label}</p>
          <p className="text-gray-300 opacity-90 mb-1 leading-snug">{badge.description}</p>
          {badge.awardedAt && (
            <p className="text-gray-400 italic text-[10px]">
              Awarded {formatBadgeDate(badge.awardedAt)}
            </p>
          )}
        </div>
      )}
    </div>
  );
};

export default BadgeChip;
